import store from '../store';

const permission = {
	inserted: function (el, binding) {
		let has_permission = binding.value.map(item => {
			return store.getters.store_permissions.indexOf(item) >= 0;
		}).reduce((x, y) => x || y);
		if (!has_permission) {
			el.style.display = 'none';
		}
	},
}
export default permission;